"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _hopsSdkJs = require("@hps/hops-sdk-js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("./Button.js"));
var _Flex = _interopRequireDefault(require("./Flex.js"));
var _Hidden = _interopRequireDefault(require("./Hidden.js"));
var _TextField = _interopRequireDefault(require("./TextField.js"));
var _TouchKeyboard = _interopRequireDefault(require("./TouchKeyboard.js"));
var _withMobile = _interopRequireDefault(require("../Hoc/withMobile.js"));
var _NumericInputModule = _interopRequireDefault(require("./NumericInput.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * NumericInput
 * Handles user input from a keypad/TextField (as a string) and returns it as a valid number.
 * Optionally formats the **UI** as a currency string (NOT the value).
 * 
 * @param {*} props 
 * @returns 
 */const NumericInput = props => {
  const {
    children,
    formatAsCurrency,
    label,
    okLabel,
    onCancel,
    onChange,
    onSubmit,
    showKeypad,
    value
  } = props;
  const inputRef = /*#__PURE__*/_react.default.createRef();
  const [error, setError] = (0, _react.useState)(false);
  const [stringValue, setStringValue] = (0, _react.useState)(null);
  const [numericValue, setNumericValue] = (0, _react.useState)(null);

  /**
   * Handle the string value from the TextField or TouchKeyboard changing.
   * Convert to a numeric value which is our output
   */
  const handleChangeAmount = (0, _react.useCallback)(amount => {
    if (!amount) {
      setStringValue(null);
      setNumericValue(null);
      return;
    }

    // Strip any currency formatting from the string and convert to a number
    const nakedStringValue = amount.toString().replace(/[^0-9]+/g, "");
    const newNumericValue = Number(nakedStringValue);

    /** Uncontrolled values */
    setStringValue(newNumericValue.toString());
    setNumericValue(newNumericValue);

    /** Controlled value */
    onChange?.(newNumericValue);
    setError(false);
  }, [onChange]);

  /**
   * Clear button pressed
   */
  const handleClear = () => {
    handleChangeAmount("");
  };

  /**
   * Error state on input changed
   */
  (0, _react.useEffect)(() => {
    if (error) inputRef?.current?.select?.();
  }, [error, inputRef]);

  /**
   * Controlled value changed outside this component
   */
  (0, _react.useEffect)(() => {
    handleChangeAmount(value);
  }, [handleChangeAmount, value]);

  /**
   * OK/Enter button pressed
   */
  const handleSubmit = e => {
    e?.preventDefault?.();
    if (isFormValidValid()) onSubmit?.(numericValue);else setError(true);
  };
  const isFormValidValid = () => {
    return !!numericValue;
  };
  const formStyles = {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    width: "100%"
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("form", {
    onSubmit: handleSubmit,
    style: formStyles,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, {
      alignItems: "center",
      justifyContent: "space-between",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
        columnar: !props.isMobile,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
          gap: 0.5,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
            autoFocus: true,
            className: _NumericInputModule.default.amountInput,
            error: error,
            errorText: "Please enter an amount.",
            inputRef: inputRef,
            label: label,
            maxLength: 15,
            onChange: handleChangeAmount,
            required: true,
            touchKeyboardIcon: false,
            type: props.formatAsPassword ? "password" : undefined,
            value: formatAsCurrency ? _hopsSdkJs.Localisation.formatCurrency(stringValue) : stringValue
          }), children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Hidden.default, {
            hidden: !showKeypad,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TouchKeyboard.default, {
              fontSize: "2rem",
              inline: true,
              numeric: true,
              onChange: handleChangeAmount,
              value: stringValue
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
            gap: 0.5,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
              className: _NumericInputModule.default.enterButton,
              disabled: !isFormValidValid(),
              onClick: handleSubmit,
              label: okLabel,
              size: "large",
              variant: "contained"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Hidden.default, {
              hidden: !props.onCancel,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
                label: "Cancel",
                size: "large",
                onClick: onCancel
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
              color: "error",
              label: "Clear",
              size: "large",
              onClick: handleClear
            })]
          })
        })]
      })
    })
  });
};
NumericInput.propTypes = {
  children: _propTypes.default.node,
  formatAsCurrency: _propTypes.default.bool,
  formatAsPassword: _propTypes.default.bool,
  label: _propTypes.default.string,
  okLabel: _propTypes.default.string,
  onCancel: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onSubmit: _propTypes.default.func,
  showKeypad: _propTypes.default.bool,
  value: _propTypes.default.number
};
NumericInput.defaultProps = {
  formatAsCurrency: false,
  formatAsPassword: false,
  okLabel: "Enter",
  showKeypad: true
};
var _default = exports.default = (0, _withMobile.default)(NumericInput);